import { navigate } from "../lib/router";
import { summarizeBoardPlacements } from "../lib/find-placements";
import type { FindBoardPlacement } from "../lib/types";
import { ProductImage, sourceLabelFor } from "./ProductImage";

interface ProductCardProduct {
  id: number;
  url: string;
  title: string;
  imageUrl: string | null;
  imageScale?: number;
  imageOffsetX?: number;
  imageOffsetY?: number;
  boardPlacements?: FindBoardPlacement[];
}

export interface BoardProductCardProps {
  product: ProductCardProduct;
  onRemove?: (productId: number) => void;
}

export function BoardProductCard({ product, onRemove }: BoardProductCardProps) {
  const href = `/finds/${product.id}`;
  const placementSummary = summarizeBoardPlacements(product.boardPlacements ?? []);
  const go = (e: React.MouseEvent) => {
    e.preventDefault();
    navigate(href);
  };

  return (
    <article className="product-card product-card-bg panel-surface flex flex-col overflow-hidden rounded-[14px] relative group">
      {onRemove && (
        <button
          className="absolute top-2 right-2 z-10 w-6 h-6 rounded-full bg-black/50 text-white text-sm leading-none flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
          onClick={() => onRemove(product.id)}
          aria-label="Remove from board"
        >
          ×
        </button>
      )}
      <a href={href} onClick={go}>
        <ProductImage
          imageUrl={product.imageUrl}
          title={product.title}
          imageScale={product.imageScale}
          imageOffsetX={product.imageOffsetX}
          imageOffsetY={product.imageOffsetY}
        />
      </a>
      <div className="flex flex-col gap-[0.35rem] px-4 pt-[0.95rem] pb-4 self-start">
        <a className="font-semibold hover:text-white" href={href} onClick={go}>
          {product.title}
        </a>
        <span className="text-[0.93rem] text-muted">{sourceLabelFor(product.url)}</span>
        {placementSummary && (
          <span className="text-[0.88rem] text-muted">{placementSummary}</span>
        )}
      </div>
    </article>
  );
}
